module.exports = __webpack_public_path__ + "static/media/www.hollywood.fi.e026877a.jpg";